// Keyed by "folder/exact-filename" (e.g. "landscape/A7403697 (1).jpg").
// Only photos listed here show a location caption in the lightbox.
export const photoLocations = {
  // Landscape
  "landscape/1.JPG": "Antelope Canyon, Page, AZ",
  "landscape/2.JPG": "Zabriskie Point, Death Valley National Park, CA",
  "landscape/3.JPG": "El Capitan, Yosemite National Park, CA",
  "landscape/4.JPG": "Half Dome, Yosemite National Park, CA",
  "landscape/5.JPG": "Yangshuo, Guangxi, China",
  "landscape/7.JPG": "Yangshuo, Guangxi, China",
  "landscape/10.JPG": "Sequoia National Park, CA",
  "landscape/12.JPG": "Wilson Arch, near Moab, UT",
  "landscape/13.JPG": "Zabriskie Point, Death Valley National Park, CA",
  "landscape/14.JPG": "Badwater Basin, Death Valley National Park, CA",
  "landscape/15.JPG": "Horseshoe Bend, Page, AZ",
  "landscape/18.JPG": "Antelope Canyon, Page, AZ",
  "landscape/19.JPG": "Lake Crescent from Mount Storm King, Olympic National Park, WA",
  "landscape/20.JPG": "Longji Rice Terraces, Guangxi, China",
  "landscape/31.jpg": "Cappadocia, Türkiye",
  "landscape/A7402092 (1).jpg": "Green River Overlook, Canyonlands National Park, UT",
  "landscape/A7402272 (1).jpg": "Bryce Canyon National Park, UT",
  "landscape/A7402310 (1).jpg": "Bryce Canyon National Park, UT",
  "landscape/A7402710 (1).jpg": "Antelope Canyon, Page, AZ",
  "landscape/A7403184 (1).jpg": "Smith Rock State Park, OR",
  "landscape/A7403697 (1).jpg": "Point Reyes Lighthouse, Point Reyes National Seashore, CA",
  "landscape/A7403765 (1).jpg": "Pierce Point Ranch, Point Reyes National Seashore, CA",
  "landscape/A7403801 (1).jpg": "Tule Elk Reserve, Point Reyes National Seashore, CA",
  "landscape/G07A5954 (1).jpg": "Giant Sequoia grove, Sierra Nevada, CA",
  "landscape/dji_fly_20240728_110442_678_1722197574753_photo_optimized.jpg": "Lake Tahoe, CA/NV",
  "landscape/dji_fly_20251128_113440_754_1764398449004_photo_optimized (1).jpg":
    "Natural Bridges, Samuel H. Boardman State Scenic Corridor, OR",

  // City
  "city/4.JPG": "Chicago, IL",
  "city/A7403167 (1).jpg": "San Francisco, CA",
};
